<template>
  <div class="sidebar-wrapper-docs">
    <div class="sidebar-template">
      <img src="../assets/logo_canplast.png" alt="" />
      <div class="separator_"></div>
      <sidebar-item
        :link="{
          name: 'FACTURAS',
          icon: 'far fa-file-alt',
          path: '/inicio',
        }"
      />
      <sidebar-item
        v-if="!pendingCustomer"
        :link="{
          name: 'CRÉDITOS',
          icon: 'far fa-credit-card',
          path: '/solicitudcredito',
        }"
      />
      <sidebar-item
        v-if="!pendingCustomer"
        :link="{
          name: 'PEDIDOS',
          icon: 'far fa-plus-square',
          path: '/solicitud-pedido',
        }"
      />
      <div class="separator_"></div>
      <base-button
        type="warning"
        outline
        @click="logout"
        class="log-out-button"
      >
        <i class="fas fa-sign-out-alt"></i> Cerrar sesión
      </base-button>
    </div>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

export default {
  created() {
    firebase
      .firestore()
      .collection("NuevosClientes")
      .where("f_rfc", "==", localStorage.getItem("rfc"))
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.size > 0) {
          this.pendingCustomer = true;
        } else {
          this.pendingCustomer = false;
        }
      });
  },
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
  },
  beforeMount() {
    this.user = firebase.auth().currentUser;
  },
  data() {
    return {
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
      user: null,
      tableData: [],
      pendingCustomer: true,
    };
  },
  mounted() {
    /* firebase.firestore().collection("pod").where("ubicacion", "==", "MEX-02").where("timestamp", ">=", "1590969600").orderBy("timestamp", "desc").get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          var data = doc.data();
          //console.log("d", data)
          var url = '';
          firebase.firestore().collection('paqueterias').where('name','==',data.paqueteria).get().then(function(querySnapshot2) {
            querySnapshot2.forEach(function(doc2) {
              
              if(doc2.data().url){
                url = doc2.data().url.replace("{NUM_RASTREO}", data.rastreo);
              }
            })
          });
          
              this.tableData.push({
                choferNombre: data.choferNombre,
                choferTelefono: data.choferTelefono,
                clienteCodigo: data.clienteCodigo,
                clienteNombre: data.clienteNombre,
                dateFormatted: data.dateFormatted,
                factura: data.factura,
                fecha: data.fecha,
                observaciones: data.observaciones,
                paqueteria: data.paqueteria,
                rastreo: data.rastreo,
                recibio: data.recibio,
                timestamp: data.timestamp,
                tipo_entrega: data.tipo_entrega,
                ubicacion: data.ubicacion,
                url_rastreo: url,
                url_photo: data.url_photo})
             
            

          
        })
      })

      setTimeout(() => {
        console.log("data,",this.tableData)
      }, 120000); */
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          localStorage.clear();
          this.$router.replace("login");
        });
    },
  },
};
</script>
<style>

.sidebar-wrapper-docs {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
}

.main-content {
  flex: 1;
}
.sidebar-template {
  position: sticky;
  top: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-color: #F6F9FC;
  gap: 14px;
  height: 100vh;
  min-width: 250px;
  padding: 24px;
  padding-top: 24px;
  box-shadow: 10px 0px 8px rgba(0, 0, 0, 0.1);
  z-index: 3;
}

.sidebar-template img {
  max-width: 180px;
}

.separator_ {
  margin: 4px 0px;
}

.log-out-button {
  position: absolute !important;
  bottom: 24px;
  background-color: #E9ECEF !important;
  color: #00000060 !important;
  border: none !important; 
  border-radius: 16px !important;
  
}

.log-out-button:hover {
  background-color: #E23255 !important;
  color: #FFF !important;
}
</style>
